import PromotionList from './components/PromotionList';
import {bindActionCreators} from 'redux';
import withRouter from 'react-router-dom/withRouter'
import values from 'lodash/values';
import get from 'lodash/get';
import {connect} from 'react-redux';

import {
    loadPromotions,
    updatePromotion,
    loadAgencies,
    loadBrands,
    loadCampaignsForAgency
} from '../../shared/redux/entities/actions'

function mapStateToProps(state, props) {
    const brandId = props.brandId;
    const brands = values(state.entities.companies)
        .filter((b) => b.name && b.name.length > 0 && b.isBrand)
        .sort((a, b) => (a.name || '').localeCompare((b.name || '')))
    const promotions = values(get(state, ['entities', 'promotions'], {}))
        .map((r) => {
            r.brand = brands.filter((b) => b.id === r.brandId).shift() || {};
            r.agency = get(state, ['entities', 'agencies', r.agencyId], {});
            return r;
        })

    return {
        promotions: brandId ? promotions.filter((r) => r.brandId === brandId) : promotions,
        brands: brands,
        brandId: brandId,
        agencies: values(get(state, ['entities', 'agencies'], {}))
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        loadPromotions,
        updatePromotion,
        loadAgencies,
        loadBrands
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PromotionList));



// WEBPACK FOOTER //
// ./src/routes/PromotionList/index.js